module.exports = __webpack_public_path__ + "static/media/Gotham-Black.24559cb5.woff";